import { UserRoles } from "~enums/userRoles";

const isTeamManagerProductRole = (role: UserRoles) => {
  const teamManagerProductRoles = [UserRoles.EntityGroupAdmin, UserRoles.EntityGroupManager, UserRoles.EntityManager];
  return teamManagerProductRoles.includes(role);
};

export default isTeamManagerProductRole;
